export interface AccountsState {
  currentAccount?: string;
  availableAccounts: AvailableAccount[];
}

export interface AccountsResponse {
  clients: AvailableAccount[];
}

export interface AvailableAccount {
  domain: string;
  createdAt: Date;
  googleAdminEmail?: string | null;
  name?: string | null;
  website?: string | null;
  address?: string | null;
  phone?: string | null;
  photoUrl?: string | null;
}

export const CURRENT_ACCOUNT_LOCAL_STORAGE_KEY = "currentAccount";
